const jiadaCartUpdateTimers = new Map();

function getCartSectionsToRender() {
  const sections = [
    {
      id: 'cart-drawer',
      selector: '#CartDrawer',
    },
    {
      id: 'cart-icon-bubble',
      selector: '#cart-icon-bubble',
    },
  ];

  const mainItems = document.getElementById('main-cart-items');
  if (mainItems) {
    sections.push({
      id: mainItems.dataset.id || 'main-cart-items',
      selector: '#main-cart-items .js-contents',
    });
  }

  const mainFooter = document.getElementById('main-cart-footer');
  if (mainFooter) {
    sections.push({
      id: mainFooter.dataset.id || 'main-cart-footer',
      selector: '#main-cart-footer .js-contents',
    });
  }

  return sections;
}

function sectionElement(html, selector) {
  if (!html) return null;
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
}

function replaceSectionInner(html, selector) {
  const target = document.querySelector(selector);
  const source = sectionElement(html, selector);
  if (target && source) target.innerHTML = source.innerHTML;
}

function syncHeaderCartCount(itemCount) {
  const cartLink = document.querySelector('#cart-icon-bubble');
  if (!cartLink) return;

  const count = Math.max(0, Number.parseInt(itemCount, 10) || 0);
  let bubble = cartLink.querySelector('.cart-count-bubble');

  if (count === 0) {
    bubble?.remove();
    cartLink.setAttribute('aria-label', 'Cart');
    return;
  }

  if (!bubble) {
    bubble = document.createElement('div');
    bubble.className = 'cart-count-bubble';
    bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
    cartLink.appendChild(bubble);
  }

  const visibleCount = bubble.querySelector('[aria-hidden="true"]');
  const accessibleCount = bubble.querySelector('.visually-hidden');
  const itemLabel = count === 1 ? 'item' : 'items';

  if (visibleCount) visibleCount.textContent = String(count);
  if (accessibleCount) accessibleCount.textContent = `${count} ${itemLabel}`;
  cartLink.setAttribute('aria-label', `Cart, ${count} ${itemLabel}`);
}

function renderSynchronizedCart(cart, sections) {
  if (!cart.sections) {
    window.location.reload();
    return;
  }

  sections
    .filter((section) => section.id !== 'cart-drawer')
    .forEach((section) => replaceSectionInner(cart.sections[section.id], section.selector));

  document.querySelector('cart-items')?.classList.toggle('is-empty', cart.item_count === 0);
  document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cart.item_count === 0);

  const drawer = document.querySelector('cart-drawer');
  const drawerTarget = document.getElementById('CartDrawer');
  const drawerSource = sectionElement(cart.sections['cart-drawer'], '#CartDrawer');
  if (drawerTarget && drawerSource) {
    drawerTarget.innerHTML = drawerSource.innerHTML;
    drawer?.classList.toggle('is-empty', cart.item_count === 0);
    const overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
  }

  syncHeaderCartCount(cart.item_count);
  if (window.JiadaWishlist) window.JiadaWishlist.refresh(document);
}

function displayCartUpdateError(message, input) {
  const fallback = 'There was an error while updating your cart. Please try again.';
  document.querySelectorAll('#cart-errors, #CartDrawer-CartErrors').forEach((element) => {
    element.textContent = message || fallback;
  });
  if (input?.isConnected) input.value = input.defaultValue;
}

async function updateCartByKey(lineKey, quantity, input) {
  const sections = getCartSectionsToRender();

  try {
    const response = await fetch(window.routes?.cart_change_url || '/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: lineKey,
        quantity,
        sections: sections.map((section) => section.id),
        sections_url: window.location.pathname,
      }),
    });
    const cart = await response.json();
    if (!response.ok || cart.errors) throw new Error(cart.description || cart.message || cart.errors);
    renderSynchronizedCart(cart, sections);
  } catch (error) {
    displayCartUpdateError(error.message, input);
  }
}

document.addEventListener(
  'change',
  (event) => {
    const input = event.target.closest(
      'cart-items .quantity__input[data-quantity-line-key], cart-drawer-items .quantity__input[data-quantity-line-key]'
    );
    if (!input) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const lineKey = input.dataset.quantityLineKey;
    const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
    window.clearTimeout(jiadaCartUpdateTimers.get(lineKey));
    jiadaCartUpdateTimers.set(
      lineKey,
      window.setTimeout(() => {
        jiadaCartUpdateTimers.delete(lineKey);
        updateCartByKey(lineKey, quantity, input);
      }, 180)
    );
  },
  true
);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState.sections || !parsedState.sections[section.id]) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    const drawerItems = this.querySelector('cart-drawer-items');
    if (drawerItems) drawerItems.classList.remove('is-empty');
    if (window.JiadaWishlist) window.JiadaWishlist.refresh(this);

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
